import moment from 'moment'
import templateUrl from './rs-commissions-grid-archive.component.html'

export const RsCommissionsArchiveGridComponent = {
    templateUrl,
    controller: RsCommissionsGridArchiveController,
    controllerAs: "vm",
    bindings: {
        payrollID: "<?payrollId",
        icdCorporationID: "<?icdCorporationId",
        programID: "<?programId",
        storeID: "<?storeId",
        filteredEmployeeID: "<?filteredEmployeeId",
    }
}

function RsCommissionsGridArchiveController(apexApiUrl, $q, payrollService, payrollDashboardService, payStubService,
    utilityService, employeeService, icdCorporationService) {
    'ngInject'
    const vm = this;
    vm.$onInit = $onInit;
    vm.icdCorporationID;
    vm.programID;
    vm.storeID;
    vm.payrollID;
    vm.filteredEmployeeID;
    vm.allowCompanySelect;
    vm.activeProgramStorePairs = [];
    vm.programStorePair;
    vm.statementOfEarnings;
    vm.maxEmployeesPerDay = 0;
    vm.loaded = false;
    // Need to inject window variables into vm to use them.
    vm.Math = Math;
    /**
     * The selected pay week.
     */
    vm.payWeek;
    /**
     * The list of available payroll pay weeks.
     */
    vm.payWeekList;

    vm.changePayWeek = changePayWeek;
    vm.changeProgramStore = changeProgramStore;
    vm.changeIcdCorporation = changeIcdCorporation;
    vm.onExportXlsx = onExportXlsx;
    vm.dropdownOptions = {
        optionLabel: vm.allowCompanySelect ? 'Select' : '',
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#company-list").data("kendoDropDownList");
                const source = vm.icdCorporations;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.active === true)
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }

    function $onInit() {
        vm.loaded = false;

        const canSelectCompanyRoles = ["Hub", "National Consultant", "Regional Consultant"];
        const allowCompanySelectLoaded = employeeService.retrieveIdentity()
            .then(identity => {
                vm.allowCompanySelect = identity || identity.Roles.some(p => canSelectCompanyRoles.some(q => q === p));
            });

        const dataLoaded = loadIcdCorporations()
            .then(selectDefaultIcdCorporation)
            .then(function () {
                return loadPayWeeks();
            })
            .then(selectDefaultPayWeek)
            .then(loadActiveProgramStorePairs)
            .then(selectDefaultActiveProgramStorePair)
            .then(function (programStorePair) {
                return loadStatementOfEarnings(vm.payWeek, vm.programStorePair, vm.filteredEmployeeID);
            })
            .then(pushPageStateChange)

        const loaded = $q.all([allowCompanySelectLoaded, dataLoaded]);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loaded, "Initial load failed")
        )
            .then(function () {
                vm.loaded = true;
            });
    }

    function pushPageStateChange() {
        vm.payrollID = vm.payWeek ? vm.payWeek.PayrollID : null;
        vm.programID = vm.programStorePair ? vm.programStorePair.ProgramID : null;
        vm.storeID = vm.programStorePair ? vm.programStorePair.StoreID : null;

        const query = {
            IcdCorporationID: vm.icdCorporationID || "",
            ProgramID: vm.programID || "",
            StoreID: vm.storeID || ""
        }
        if (vm.filteredEmployeeID) {
            query.FilteredEmployeeID = vm.filteredEmployeeID;
        }

        window.history.replaceState(null, '', `/Payroll/StatementOfEarningsArchive/${vm.payrollID || ""}`
            + utilityService.queryStringify(query));
    }

    function changeProgramStore() {
        if (!vm.programStorePair || !vm.programStorePair.Name) {
            vm.statementOfEarnings = null;
            return;
        }
        utilityService.showLoading();
        return loadStatementOfEarnings(vm.payWeek, vm.programStorePair, vm.filteredEmployeeID)
            .then(function (statementOfEarnings) {
                const query = {
                    IcdCorporationID: vm.icdCorporationID || "",
                    ProgramID: vm.programID || "",
                    StoreID: vm.storeID || ""
                }
                if (vm.filteredEmployeeID) {
                    query.FilteredEmployeeID = vm.filteredEmployeeID;
                }
                window.history.replaceState(null, '', `/Payroll/StatementOfEarningsArchive/${vm.payrollID || ""}`
                    + utilityService.queryStringify(query));
                vm.programID = statementOfEarnings.ProgramID;
                vm.storeID = statementOfEarnings.StoreID;
            })
            .catch(function () {
                vm.activeProgramStorePairs = [];
                vm.statementOfEarnings = null;
            })
            .then(utilityService.hideLoading);
    }

    function changePayWeek() {
        if (!vm.payWeek || !vm.payWeek.PayrollID) {
            vm.payrollID = null;
            vm.activeProgramStorePairs = [];
            vm.statementOfEarnings = null;
            vm.programStorePair = null;
            vm.statementOfEarnings = null;
            return;
        }

        utilityService.showLoading();
        return loadActiveProgramStorePairs(vm.payWeek)
            .then(selectDefaultActiveProgramStorePair)
            .then(function (programStorePair) {
                return loadStatementOfEarnings(vm.payWeek, vm.programStorePair, vm.filteredEmployeeID);
            })
            .then(pushPageStateChange)
            .catch(() => { })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function changeIcdCorporation() {
        let selectNewPayWeek;
        if (!vm.icdCorporation || !vm.icdCorporation.IcdCorporationID) {
            vm.icdCorporationID = null;
            vm.payWeek = null;
            selectNewPayWeek = $q.when(vm.payWeek);
        } else {
            utilityService.showLoading();
            selectNewPayWeek = loadPayWeeks()
                .then(function (payWeeks) {
                    // Try to preselect a payroll that intersects with the currently selected payroll.
                    const payWeek = payWeeks.filter(function (payroll) {

                        return vm.payWeek && moment(payroll.StartDate).isSameOrBefore(vm.payWeek.EndDate)
                            && moment(vm.payWeek.StartDate).isSameOrBefore(payroll.EndDate);
                    })[0];
                    if (!payWeek) {
                        // Fall back to the initial load default selection logic.
                        return selectDefaultPayWeek(vm.payWeekList);
                    }
                    return payWeek;
                })
                .then(function (payWeek) {
                    vm.payWeek = payWeek;
                })
                .then(function () {
                    vm.icdCorporationID = vm.icdCorporation.IcdCorporationID;
                });
        }
        return selectNewPayWeek.then(changePayWeek)
            .catch(function (ex) {
                console.error(ex);
                alert("Changing corporation failed. " + (ex.statusText || ex.message !== "" ? ex : ex.message));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function loadPayWeeks() {
        let payWeeks;
        if (vm.filteredEmployeeID) {
            payWeeks = payStubService.retrievePayStubs(vm.filteredEmployeeID);
        } else {
            payWeeks = $q.when().then(function () {
                return vm.icdCorporation ? vm.icdCorporation.DivisionCountries.reduce(function (payrolls, dc) {
                    // Add each distinct payroll of the corporation.
                    dc.Payrolls.forEach(function (payroll) {
                        if (!payrolls.reduce(function (any, p) {
                            return any || p.PayrollID === payroll.PayrollID;
                        }, false)) {
                            payrolls.push(payroll);
                        }
                    });
                    return payrolls;
                }, []) : [];
            });
        }
        return payWeeks
            .then(sortPayStubs)
            .then(function (payWeeks) {
                payWeeks.forEach(function (payWeek) {
                    // Add formatting to the select list text.
                    payWeek.Text = kendo.format("{2}{0:MM/dd/yyyy} - {1:MM/dd/yyyy}", payWeek.StartDate, payWeek.EndDate,
                        vm.icdCorporationID ? "" : payWeek.ClientName + ": "); // Only show company name if corporationID is missing.
                    payWeek.DateSpan = kendo.format("{0:MMM dd, yyyy} - {1:MMM dd, yyyy}", payWeek.StartDate, payWeek.EndDate);
                });
                vm.payWeekList = payWeeks;
                return vm.payWeekList;
            });
    }

    function selectDefaultPayWeek(payWeeks) {
        // Select the pay week specified by id.
        vm.payWeek =
            payWeeks.filter(function (payWeek) {
                return payWeek.PayrollID === vm.payrollID;
            })[0]
            // Select the latest submitted payroll.
            || payWeeks.filter(function (payWeek) {
                return payWeek.Locked;
            })
                .sort(function (p, q) {
                    return p.StartDate > q.StartDate ? -1 : 1;
                })[0]
            || payWeeks[0];
        return vm.payWeek;
    }

    function loadIcdCorporations() {
        return icdCorporationService.retrieveIcdCorporationStatusList({ IcdCorporationStatusID: 1 }).then(function (result) {
            vm.corpStatuses = result.filter(x => x.Active).map(x => x.IcdCorporationID);
            return payrollDashboardService.retrievePayrollCorporationsActive();
        }).then(function (payrollCorporations) {
            return payrollCorporations.filter(function (payrollCorporation) {
                return payrollCorporation.CanRead;
            }).sort((a, b) => {
                if (a.CanUpdate && !b.CanUpdate) {
                    return -1;
                } else if (b.CanUpdate && !a.CanUpdate) {
                    return 1;
                }
                if (a.Owner < b.Owner) {
                    return -1;
                } else if (a.Owner > b.Owner) {
                    return 1;
                }
                if (a.ClientName < b.ClientName) {
                    return -1;
                } else if (a.ClientName > b.ClientName) {
                    return 1;
                }
                return 0;
            });
        })
            .then(function (icdCorporations) {
                vm.icdCorporations = icdCorporations;
                for (const icdCorporation of icdCorporations) {
                    icdCorporation.text = `${icdCorporation.Owner} - ${icdCorporation.ClientName}`;
                    icdCorporation.active = vm.corpStatuses.includes(icdCorporation.IcdCorporationID);
                }
                return icdCorporations;
            })
    }

    function selectDefaultIcdCorporation() {
        // Pick the selected corporation. If a payroll ID was given, use the corporation
        // associated with that payroll. If a corporation ID was given, use that corporation.
        // Otherwise, pick the first in the list.
        vm.icdCorporation =
            vm.icdCorporations.filter(function (icdCorporation) {
                return icdCorporation.DivisionCountries.reduce(function (any, dc) {
                    return any || dc.Payrolls.reduce(function (any, payroll) {
                        return any || payroll.PayrollID === vm.payrollID;
                    }, false)
                }, false)
            })[0]
            || vm.icdCorporations.filter(function (icdCorporation) {
                return icdCorporation.IcdCorporationID === vm.icdCorporationID;
            })[0]
            || vm.icdCorporations[0];

        vm.icdCorporationID = vm.icdCorporation ? vm.icdCorporation.IcdCorporationID : null;
    }

    function loadActiveProgramStorePairs(payWeek) {
        if (!payWeek) {
            vm.activeProgramStorePairs = [];
            return vm.activeProgramStorePairs;
        }

        return payrollService.retrieveActiveProgramStorePairs(payWeek.PayrollID, vm.filteredEmployeeID)
            .then(function (activeProgramStorePairs) {
                vm.activeProgramStorePairs = activeProgramStorePairs;
                return vm.activeProgramStorePairs;
            });
    }

    function selectDefaultActiveProgramStorePair(activeProgramStorePairs) {
        vm.programStorePair = activeProgramStorePairs.filter(function (pair) {
            return pair.ProgramID === vm.programID && pair.StoreID === vm.storeID;
        })[0] || activeProgramStorePairs[0];
        return vm.programStorePair;
    }

    function loadStatementOfEarnings(payWeek, programStorePair, filteredEmployeeID) {
        if (!payWeek || !programStorePair) {
            vm.statementOfEarnings = null;
            return vm.statementOfEarnings;
        }

        return payrollService.retrieveStatementOfEarnings(payWeek.PayrollID, programStorePair.ProgramID,
            programStorePair.StoreID, filteredEmployeeID)
            .then(function (statementOfEarnings) {
                vm.statementOfEarnings = statementOfEarnings;
                // Perform a calculation to determine how many padding columns are required.
                vm.maxEmployeesPerDay = statementOfEarnings.EarningsDates.reduce(function (curr, date) {
                    return Math.max(curr, date.EmployeeEarnings.length);
                }, 0);
                return statementOfEarnings;
            });

    }


    function onExportXlsx() {
        if (!vm.payWeek || !vm.activeProgramStorePairs.length) {
            return;
        }
        //Always  load all programs
        window.location.href = apexApiUrl + "payroll/" + vm.payWeek.PayrollID + "/statement-of-earnings.xlsx"
            + "?&filteredEmployeeID=" + vm.filteredEmployeeID;

    }

    function sortPayStubs(payStubs) {
        // Sort the pay stub by corporation and date.
        return payStubs.sort(function (a, b) {
            return a.ClientName < b.ClientName ? -1 :
                a.StartDate < b.StartDate ? 1 : -1;
        });
    }
}
